import { DropdownProfileMenuContainer } from './dropdownProfileMenu';

export default DropdownProfileMenuContainer
